import _omit from 'lodash/omit'
import api from './api'

/**
 * Initialize Rewards
 */
export const initRewards = () => {
  const initRewardsUrl = `/v1/${process.env.VUE_APP_DEVICE}/rewards/init`
  return api()
    .url(initRewardsUrl)
    .get()
}

export const redeemRewardBox = (selectedRewardBox, deliveryAddress) => {
  const address = _omit(deliveryAddress, ['primary', 'id'])

  const baseUrl = `/v1/${process.env.VUE_APP_DEVICE}/rewards/reward-boxes/redeem`
  return api()
    .url(baseUrl)
    .post({
      address,
      items: [
        {
          rewardBoxId: selectedRewardBox.id,
          quantity: 1,
        },
      ],
    })
}

export const redeemCart = ({ account, items }) => {
  return api()
    .url(`/v3/${process.env.VUE_APP_DEVICE}/rewards/redeem`)
    .post({ account, items })
}

export const setupAutoRewards = ({ account, poolIncentivePreference }) => {
  return api()
    .url(`/v2/${process.env.VUE_APP_DEVICE}/rewards/setup`)
    .post({ account, poolIncentivePreference })
}

/**
 * Remove Auto Rewards
 * @param {Number} preferenceId - Preference ID for selected Reward
 */
export const turnOffAutoRewards = (preferenceId) => {
  const deleteUrl = `/v1/${process.env.VUE_APP_DEVICE}/rewards/${preferenceId}`

  return api()
    .url(deleteUrl)
    .delete()
}

export const getIncentiveCatalog = (incentiveCatalogCd) => {
  const getIncentiveCatalogUrl = `/v1/${process.env.VUE_APP_DEVICE}/rewards/incentive-catalog/${incentiveCatalogCd}`
  return api()
    .url(getIncentiveCatalogUrl)
    .get()
}
